import { Alert, Box, Button, Container, Grid, Paper, TextField, Typography } from "@mui/material";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { SetPageTitle } from "../SetPageTitle";
import { deleteUser, getAuth } from "firebase/auth";
import { doc, deleteDoc } from "firebase/firestore";
import { FireactContext } from "../Fireact";
import { AuthContext } from "../Auth";

export const UserDelete = () => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const title = "Delete Account";
    const navigate = useNavigate();

    const auth = getAuth();
    const { firestoreInstance } = useContext(AuthContext);

    const { config } = useContext(FireactContext);
    const pathnames = config.pathnames;

    useEffect(() => {
        // Only set loaded true if both firestoreInstance and auth.currentUser are available
        if (firestoreInstance && auth.currentUser) {
            setLoaded(true);
        } else {
            setLoaded(false);
        }
    }, [firestoreInstance, auth.currentUser]);

    return (
        <Container maxWidth="md">
            <SetPageTitle title={title} />
            <Paper>
                <Box p={2}>
                    <Typography component="h1" variant="h4" align="center">{title}</Typography>
                </Box>
                {error !== null &&
                    <Box p={2}>
                        <Alert severity="error">{error}</Alert>
                    </Box>
                }
                <Box p={2}>
                    <Typography>Please confirm your email address to delete your user account.</Typography>
                    <TextField required fullWidth name="email" label="Email Address" type="email" autoComplete="email" margin="normal" onChange={e => setEmail(e.target.value)} />
                </Box>
                <Box p={2}>
                    <Grid container>
                        <Grid item xs>
                            <Button type="button" color="secondary" variant="outlined" disabled={processing} onClick={() => {
                                navigate(pathnames.UserProfile);
                            }}>Back</Button>
                        </Grid>
                        <Grid item>
                            <Button
                                type="button"
                                color="error"
                                variant="contained"
                                disabled={processing || !loaded}
                                onClick={() => {
                                    if (!loaded) return;
                                    setProcessing(true);
                                    setError(null);
                                    if(!auth.currentUser || auth.currentUser.email !== email){
                                        setError("The email address does not match with your email address.");
                                        setProcessing(false);
                                    }else{
                                        const uid = auth.currentUser.uid;
                                        // Delete Firestore user document first, then delete Auth user
                                        deleteDoc(doc(firestoreInstance, "users", uid))
                                            .then(() => {
                                                return deleteUser(auth.currentUser);
                                            })
                                            .then(() => {
                                                // refresh page
                                                document.location.href = "/";
                                            })
                                            .catch(error => {
                                                switch(error.code){
                                                    case "auth/requires-recent-login":
                                                        setError("This operation is sensitive and requires recent authentication. Log in again before retrying this request.");
                                                        break;
                                                    default:
                                                        setError(error.message);
                                                        break;
                                                }
                                                setProcessing(false);
                                            });
                                    }
                                }}
                            >
                                {loaded ? "Delete User Account" : "Initializing..."}
                            </Button>
                        </Grid>
                {!loaded && (
                    <Box p={2}>
                        <Alert severity="info">Initializing user context, please wait...</Alert>
                    </Box>
                )}
                    </Grid>
                </Box>
            </Paper>
        </Container>
    )
}